/**
 * What a component renders when it has nothing to show yet.
 *
 * Returning null is right for a published page — an image with no photo should
 * occupy no space — but it makes the editor lie: you add a component, nothing
 * appears, and the only evidence is a chip floating over the page. So the
 * component renders this marker instead of nothing. `.jobsite-empty-block` is
 * `display: none` in the site stylesheet, and the editor's own frame CSS
 * reveals it as a dashed placeholder carrying `label`.
 */
export function EmptyBlock({ label }: { label: string }) {
  return <div className="jobsite-empty-block" data-empty-label={label} aria-hidden="true" />;
}
